import { useQuery } from "@tanstack/react-query";

import useSystemStore from "@store/useSystemStore";
import { COMPANY_STAGES_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";
import companyService from "@services/company.service";

export function useCompanyStages() {
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: isAppActive,
    queryKey: [COMPANY_STAGES_QUERY_KEY],
    queryFn: async () => {
      return await companyService.getCompanyStages();
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
